export enum ImageFitMode {
  Clip = 'clip',
  Crop = 'crop',
  Fill = 'fill',
}

export function generateImageLink(url: string | null, width = 400, height?: number, fitMode?: ImageFitMode) {
  if (!url) {
    return '#';
  }

  if (url.includes('wsrv.nl')) {
    const parsed = new URL(url);
    parsed.searchParams.set('w', String(Math.round(width)));
    if (height) {
      parsed.searchParams.set('h', String(Math.round(height)));
    }
    switch (fitMode) {
      case ImageFitMode.Clip:
        parsed.searchParams.set('fit', 'inside');
        parsed.searchParams.set('we', '');
        break;
      case ImageFitMode.Crop:
        parsed.searchParams.set('fit', 'cover');
        break;
      case ImageFitMode.Fill:
        parsed.searchParams.set('fit', 'contain');
        parsed.searchParams.set('cbg', 'FFFFFF');
        break;
    }
    return parsed.toString();
  }

  if (url.includes('ik.imagekit.io')) {
    const tr = [`w-${Math.round(width)}`];
    if (height) {
      tr.push(`h-${Math.round(height)}`);
    }
    switch (fitMode) {
      case ImageFitMode.Clip:
        tr.push('c-at_max');
        break;
      case ImageFitMode.Crop:
        tr.push('c-maintain_ratio');
        break;
      case ImageFitMode.Fill:
        tr.push('cm-pad_resize', 'bg-FFFFFF');
        break;
    }
    return `${url.split('?')[0]}?tr=${tr.join(',')}`;
  }

  return url;
}
